import React from 'react';
import classNames from 'classnames';
import { Nav, NavItem, Tabs, Tab } from 'react-bootstrap';
import { Link } from 'react-router';
import api from 'api';
import DashboardMenu from './DashboardMenu';
import InventoryMenu from './InventoryMenu';
import ManagementMenu from './ManagementMenu';
import SettingsMenu from './SettingsMenu';
import HelpMenu from './HelpMenu';
import OwnerMenu from './OwnerMenu';
import WebsiteMenu from './WebsiteMenu';
import { PMS_URL } from '../../config';

class Menu extends React.Component {
  constructor(props) {
    super(props);
    // this.handleRefresh = this.handleRefresh.bind(this);
    this.state = {
      activeTab: null,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.setState({ activeTab: null });
    }
  }

  render() {
    const { currentUser } = this.props.api.getState('auth');
    if (!currentUser || !currentUser.group) return null;
    if (this.props.location.pathname.includes('/init-wizard')) return null;
    if (['admin', 'manager'].includes(currentUser.group.name)) {
      return (
        <div className="sidebar-tabs-group">
          <ul className="sidebar-tabs">
            <li className={ classNames({ active: this.isActive('/dashboard')}) } onClick={ this.handleSelect.bind(this, '/dashboard') } title="Dashboard">
              <i className="fas fa-tachometer-alt" />
            </li>
            <li className={ classNames({ active: this.isActive('/management')}) } onClick={ this.handleSelect.bind(this, '/management') } title="Management">
              <i className="fas fa-cogs" />
            </li>
            <li className={ classNames({ active: this.isActive('/inventory')}) } onClick={ this.handleSelect.bind(this, '/inventory') } title="Inventory">
              <i className="fas fa-building" />
            </li>
            <li className={ classNames({ active: this.isActive('/website')}) } onClick={ this.handleSelect.bind(this, '/website') } title="Website">
              <i className="fas fa-globe" />
            </li>
            <li className={ classNames({ active: this.isActive('/settings')}) } onClick={ this.handleSelect.bind(this, '/settings') } title="Settings">
              <i className="fas fa-wrench" />
            </li>
            <li className={ classNames({ active: this.isActive('/help')}) } onClick={ this.handleSelect.bind(this, '/help') } title="Help">
              <i className="fas fa-life-ring" />
            </li>
          </ul>
          <div className="sidebar-tabs-content">
            {
              this.isActive('/dashboard')
                ? <DashboardMenu { ...this.props } currentUser={ currentUser } />
                : null
            }
            {
              this.isActive('/management')
                ? <ManagementMenu { ...this.props } currentUser={ currentUser } />
                : null
            }
            {
              this.isActive('/inventory')
                ? <InventoryMenu { ...this.props } currentUser={ currentUser } />
                : null
            }
            {
              this.isActive('/website')
                ? <WebsiteMenu { ...this.props } currentUser={ currentUser } />
                : null
            }
            {
              this.isActive('/settings')
                ? <SettingsMenu { ...this.props } currentUser={ currentUser } />
                : null
            }
            {
              this.isActive('/help')
                ? <HelpMenu { ...this.props } currentUser={ currentUser } />
                : null
            }
          </div>
        </div>
      );
    }
    if (currentUser.group.name === "owner") return <OwnerMenu { ...this.props } currentUser={ currentUser } />;
    return null;
  }
  // handleRefresh(e) {
  //   e.stopPropagation();
  //   this.props.api.overview.getOverviewData();
  // }

  isActive(url) {
    const root = PMS_URL === '/' ? '' : PMS_URL;
    return this.state.activeTab
      ? this.state.activeTab === url
      : this.props.location.pathname.match(`^${root}${url}`);
  }
  handleSelect(tab) {
    if (tab === this.state.activeTab) {
      //if (tab === '/dashboard') this.props.api.dashboard.getDashboardMenuData();
    } else this.setState({ activeTab: tab });
  }
}

Menu.propTypes = {
  location: React.PropTypes.object,
  api: React.PropTypes.object,
  root: React.PropTypes.string,
};

export default api.connect(Menu, 'routing');



// WEBPACK FOOTER //
// ./src/frontend/layout/Menu.jsx